import makeActionCreator from 'make-action-creator'

export const fetchAll = makeActionCreator('organization/fetchAll')
export const fetchRequests = makeActionCreator('organization/fetchRequests')
export const fetchInvites = makeActionCreator('organization/fetchInvites')
export const sendInvite = makeActionCreator('organization/sendInvite')
export const selectOrganization = makeActionCreator('organization/selectOrganization')
export const editOrganization = makeActionCreator('organization/editOrganization')
